var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_c('input',{attrs:{"type":"search","placeholder":"Search"},domProps:{"value":_vm.search},on:{"input":_vm.onSearchChange}})])])}
var staticRenderFns = []

export { render, staticRenderFns }